import FileManagerBrowseModule from "./FileManagerBrowseModule.js";
import UtilsModule from "./UtilsModule.js"

let fileManagerBrowse = null;
let utils = null;

(function($){
    $("document").ready(()=>{
        fileManagerBrowse = new FileManagerBrowseModule();
        utils = new UtilsModule();
    
        let customEv = new CustomEvent("swlri-browse-module-loaded")
        window.dispatchEvent(customEv);

    })
})(jQuery)

export {
    fileManagerBrowse,
    utils
};